<ng-container *ngIf="isOpen || isPredefinedOpen">
    <div class="modal-outer-container" [ngClass]="!!overlayClass  ? overlayClass : ''" @fadeIn @fadeOut>
        <div class="backdrop" (click)="hideOnBackdropClick && hide()"></div>
        <div class="modal-container" [ngClass]="{'full-height': isFullHeight}">
            <div class="heading" *ngIf="modalHeading">
                <ng-container *ngTemplateOutlet="modalHeading; context: { data: data || predefinedData }"></ng-container>
            </div>
            <div class="body">
                <ng-container *ngTemplateOutlet="modalBody || defaultTemplate; context: { data: data || predefinedData }"></ng-container>
            </div>
            <div class="actions" *ngIf="modalActions">
                <ng-container *ngTemplateOutlet="modalActions; context: { data: data || predefinedData }"></ng-container>
            </div>
        </div>
    </div>
</ng-container>

<ng-template #defaultTemplate></ng-template>